import { LRParser } from '@lezer/lr';

// This file was generated by lezer-generator. You probably shouldn't edit it.
const Json$1 = 1,
  Logfmt$1 = 2,
  Unpack$1 = 3,
  Pattern$1 = 4,
  Regexp$1 = 5,
  Unwrap$1 = 6,
  Ip$1 = 7,
  LabelFormat$1 = 8,
  LineFormat$1 = 9,
  LabelReplace$1 = 10,
  Vector$1 = 11,
  Offset$1 = 12,
  Bool$1 = 13,
  On$1 = 14,
  Ignoring$1 = 15,
  GroupLeft$1 = 16,
  GroupRight$1 = 17,
  Decolorize$1 = 18,
  Drop$1 = 19,
  Keep$1 = 20,
  By$1 = 21,
  Without$1 = 22,
  And$1 = 23,
  Or$1 = 24,
  Unless$1 = 25,
  Sum$1 = 26,
  Avg$1 = 27,
  Count$1 = 28,
  Max$1 = 29,
  Min$1 = 30,
  Stddev$1 = 31,
  Stdvar$1 = 32,
  Bottomk$1 = 33,
  Topk$1 = 34,
  Sort$1 = 35,
  Sort_Desc$1 = 36,
  MetricExpr$1 = 93;

const keywordTokens = {
  json: Json$1,
  logfmt: Logfmt$1,
  unpack: Unpack$1,
  pattern: Pattern$1,
  regexp: Regexp$1,
  ip: Ip$1,
  label_format: LabelFormat$1,
  line_format: LineFormat$1,
  label_replace: LabelReplace$1,
  vector: Vector$1,
  offset: Offset$1,
  bool: Bool$1,
  on: On$1,
  ignoring: Ignoring$1,
  group_left: GroupLeft$1,
  group_right: GroupRight$1,
  unwrap: Unwrap$1,
  decolorize: Decolorize$1,
  drop: Drop$1,
  keep: Keep$1,
};

const specializeIdentifier = (value) => {
  return keywordTokens[value.toLowerCase()] || -1;
};

const contextualKeywordTokens = {
  by: By$1,
  without: Without$1,
  and: And$1,
  or: Or$1,
  unless: Unless$1,
  sum: Sum$1,
  avg: Avg$1,
  count: Count$1,
  max: Max$1,
  min: Min$1,
  stddev: Stddev$1,
  stdvar: Stdvar$1,
  bottomk: Bottomk$1,
  topk: Topk$1,
  sort: Sort$1,
  sort_desc: Sort_Desc$1,
};

const extendIdentifier = (value) => {
  return contextualKeywordTokens[value.toLowerCase()] || -1;
};

// This file was generated by lezer-generator. You probably shouldn't edit it.
const spec_Identifier = {__proto__:null,count_over_time:295, rate:297, rate_counter:299, bytes_over_time:301, bytes_rate:303, avg_over_time:305, sum_over_time:307, min_over_time:309, max_over_time:311, stddev_over_time:313, stdvar_over_time:315, quantile_over_time:317, first_over_time:319, last_over_time:321, absent_over_time:323, bytes:329, duration:331, duration_seconds:333};
const parser = LRParser.deserialize({
  version: 14,
  states: "EnOYQPOOO#cQPO'#DVO$rQPO'#DUOYQPO'#DUOOQO'#E_'#E_O%PQPO'#E^OOQO'#Ez'#EzO%UQPO'#EyQ%aQPOOOOQO'#FY'#FYO&bQPO'#FYO&gQPO'#FZO&lQPO'#F[OOQO'#E]'#E]OOQO'#DT'#DTOOQO'#E`'#E`OOQO'#Ea'#EaOOQO'#Eb'#EbOOQO'#Ec'#EcOOQO'#Ed'#EdOOQO'#Ee'#EeOOQO'#Ef'#EfOOQO'#Eg'#EgOOQO'#Eh'#EhOOQO'#Ei'#EiOOQO'#Ej'#EjOOQO'#Ek'#EkOOQO'#El'#ElOOQO'#Em'#EmOOQO'#En'#EnO&qQPO'#DXOOQO'#DW'#DWO'PQPO,59qOOQO'#Dd'#DdO'XQPO'#DcO'aQPO'#DbO(zQPO'#DaO*eQPO'#DaOOQO'#D`'#D`O,gQPO,59pO-uQPO,59pO-|QPO,5:wO.TQPO,5:xO.`QPO'#EwO0kQPO,5;eO0rQPO,5;eO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gOOQO,5;t,5;tOYQPO,5;uO3ZQPO,5;vO3`QPO,59sO#cQPO,59rOOQO1G/]1G/]OOQO'#Dg'#DgO3eQPO,59}O5OQPO,59}O5TQPO,59|OOQO,59|,59|O5]QPO'#DXO5zQPO'#DjO7kQPO'#DmO9XQPO'#DmOOQO'#Dm'#DmOOQO'#Dt'#DtOOQO'#Dr'#DrO+TQPO'#DrO9^QPO,59{O:wQPO'#EQO:|QPO'#EROOQO'#EU'#EUO;RQPO'#EVO;WQPO'#EYOOQO,59{,59{OOQO,59z,59zOOQO1G/[1G/[OOQO1G0c1G0cO;]QPO'#EoO.WQPO'#EoO;qQPO1G0dO;vQPO1G0dO;{QPO,5;cO<TQPO1G1PO=`QPO1G1PO=gQPO1G1PO=nQPO'#E}O?|QPO'#E|O@WQPO'#E|OYQPO1G1ROYQPO1G1ROYQPO1G1ROYQPO1G1ROYQPO1G1ROYQPO1G1RO@bQPO1G1aO@iQPO1G1bOOQO1G/_1G/_OOQO1G/^1G/^O5TQPO1G/iO@nQPO1G/iO@sQPO'#DhOB^QPO'#DhOOQO1G/h1G/hOBcQPO,59sOBiQPO,5:aOOQO'#Dk'#DkOBtQPO,5:UODeQPO'#DpOOQO'#Do'#DoOFRQPO,5:]OGlQPO,5:YOOQO,5:X,5:XOIVQPO,5:^O+TQPO,5:^O+TQPO,5:^OOQO,5:l,5:lOIeQPO'#ETOOQO'#ES'#ESOIjQPO,5:mOKTQPO'#EXOOQO'#EX'#EXOOQO'#EW'#EWOLtQPO,5:qON_QPO'#E[OOQO'#E['#E[OOQO'#EZ'#EZO!!OQPO,5:tO!#iQPO'#DaO;]QPO,5;ZO!#pQPO'#EpO!#uQPO,5;ZO!$`QPO,5;ZO!$jQPO,5;ZO!$qQPO,5;ZO!$vQPO7+&OO.WQPO7+&OOOQO'#Ex'#ExO!&WQPO1G0}OOQO1G0}1G0}O!&`QPO7+&kOYQPO7+&kO!'pQPO7+&kO!'wQPO7+&kO!(OQQO'#FOOOQO,5;i,5;iO!*^QPO,5;hO!*eQPO,5;hO!+vQPO7+&mO!+}QPO7+&mOOQO7+&m7+&mO!,[QPO7+&mO!,cQPO7+&mO!-hQPO7+&mO!-xQPO7+&{OOQO7+&|7+&|OOQO7+%T7+%TO!-}QPO7+%TO5TQPO,5:SO!.SQPO,5:SO!.XQPO1G/yOOQO1G/{1G/{OOQO1G0S1G0SOOQO1G0U1G0UOOQO,5:V,5:VO!.^QPO1G/wO!/wQPO,5:[O!/|QPO,5:ZOOQO1G/x1G/xO!0RQPO1G/xO!1lQPO,5:oO:|QPO,5:nO;RQPO,5:rO;WQPO,5:uO!1tQPO,5;^O!#uQPO1G0uO!2SQPO1G0uO!2[QPO,5;[O+TQPO,5;^O!2aQPO1G0uO!2hQPO'#EqO!2mQPO1G0uO!2aQPO1G0uO!2uQPO1G0uO!2|QPO1G0uO;lQPO1G0uOOQO1G0u1G0uOOQO<<Ij<<IjO!3XQPO<<IjO!3^QPO,5;dOOQO7+&i7+&iOOQO<<JV<<JVO!3cQPO<<JVOYQPO<<JVOOQO'#FQ'#FQO!3jQPO,5;jOOQO'#FP'#FPOOQO,5;j,5;jOOQO1G1S1G1SO!3rQPO1G1SO!5{QPO<<JgOOQO<<Ho<<HoOOQO1G/n1G/nO!6QQPO1G/nO!6VQPO7+%eOOQO1G/v1G/vOOQO1G/u1G/uOOQO1G0Z1G0ZOOQO1G0Y1G0YOOQO1G0^1G0^OOQO1G0a1G0aOOQO'#Es'#EsOOQO1G0x1G0xO!6[QPO1G0xOOQO'#Et'#EtOOQO'#Eu'#EuOOQO'#Ev'#EvOOQO7+&a7+&aOOQO1G0v1G0vO!6aQPO1G0xO!6uQPO7+&aOOQO,5;],5;]O!6}QPO7+&aO;lQPO7+&aO!7UQPO7+&aO!7aQPOAN?UOOQO1G1O1G1OO!8qQPOAN?qO!:RQPOAN?qO!:YQQO1G1UOOQO1G1U1G1UOOQO7+&n7+&nO!:bQPOAN@ROOQO7+%Y7+%YO!:gQPO<<IPO!:lQPO7+&dO!:qQPO<<I{O!:yQPO<<I{O!;RQPO'#ErO!;WQPO<<I{OOQOG24pG24pOOQOG25]G25]OOQO1G1V1G1VOOQO7+&p7+&pO!;`QPOG25mOOQOAN>kAN>kO!;eQPO<<JOOOQOAN?gAN?gO!;jQPOAN?gO!;rQPOLD+XOOQOAN?jAN?jOOQO,5:m,5:mO!;wQPO!$'NsO!;|QPO!)9D_O!<RQPO!.K9yOOQO!4//e!4//eO:|QPO'#ERO!<WQPO'#DaO!=OQPO,59pO!=YQPO'#DUOYQPO1G1ROYQPO1G1ROYQPO1G1ROYQPO1G1ROYQPO1G1ROYQPO1G1RO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gO0wQPO,5;gO!>eQPO7+&mO!>lQPO7+&mO!>yQPO7+&mO!@RQPO7+&mO!@YQPO7+&mO!?QQPO'#E{",
  stateData: "!@g~O$ROSuOS~OYZOZ[OjUOkUOlUOmUOnUOoUOpUOqUOrUOsUOtUO!sXO#vYO#wYO$SPO$VRO$X_O$Y`O$ZaO$[bO$]cO$^dO$_eO$`fO$agO$bhO$ciO$djO$ekO$flO$gmO~O|nO~O!PqO!RqO!XqO!YqOgxXhxXixX!jxX!lxX!mxX!nxX!oxX#vxX#wxX#xxX#yxX#zxX#{xX~O!]uO$PxX$WxX~P#hO$VzO~Oe{Of{O$V|O~Og!POh!OOi!PO!P!TO!j!TO!l!TO!m!TO!n!TO!o!TO#v!QO#w!QO#x!RO#y!RO#z!RO#{!SO~O!s!UO~O$V!VO~O$V!WO~O}!XO!P!XO!Q!XO!R!XO~O$T!YO$U!ZO~OV![O!O!]O~Oh!_Og!UXi!UX!P!UX!R!UX!X!UX!Y!UX!]!UX!j!UX!l!UX!m!UX!n!UX!o!UX#v!UX#w!UX#x!UX#y!UX#z!UX#{!UX$P!UX$W!UX$h!UX$T!UX~O!PqO!RqO!XqO!YqOg!TXh!TXi!TX!]!TX!j!TX!l!TX!m!TX!n!TX!o!TX#v!TX#w!TX#x!TX#y!TX#z!TX#{!TX$P!TX$W!TX$h!TX$T!TX~OP!cOQ!bOR!eOS!dOT!dOW!kOX!jOb!lOc!mOd!nO|!aO$V!hO~O!PqO!RqO!XqO!YqOgxahxaixa!jxa!lxa!mxa!nxa!oxa#vxa#wxa#xxa#yxa#zxa#{xa~O!]uO$Pxa$Wxa~P+]OgwXhwXiwX!PwX!jwX!lwX!mwX!nwX!owX#vwX#wwX#xwX#ywX#zwX#{wX~O$W!qO~P,tO$W!rO~P,tO!s!vO$SPO$V!tO~O$V!wO~OYZOZ[OjUOkUOlUOmUOnUOoUOpUOqUOrUOsUOtUO#vYO#wYO$SPO$VRO$X_O$Y`O$ZaO$[bO$]cO$^dO$_eO$`fO$agO$bhO$ciO$djO$ekO$flO$gmO~O!s!yO~P.eO$V!zO~O]!}O^!{O_!{OY#pPZ#pPj#pPk#pPl#pPm#pPn#pPo#pPp#pPq#pPr#pPs#pPt#pP!s#pP#v#pP#w#pP$S#pP$V#pP$X#pP$Y#pP$Z#pP$[#pP$]#pP$^#pP$_#pP$`#pP$a#pP$b#pP$c#pP$d#pP$e#pP$f#pP$g#pP~O!s#VO~O!O#WO~Oh#YOg!Vai!Va!P!Va!R!Va!X!Va!Y!Va!]!Va!j!Va!l!Va!m!Va!n!Va!o!Va#v!Va#w!Va#x!Va#y!Va#z!Va#{!Va$P!Va$W!Va$h!Va$T!Va~O$V#ZO~OV![O!O#[O~O}#_O!P#_O!Q!XO!R!XO!j#`O!l#`O!m#`O!n#`O!o#`O~O|#cO!`#aOg!^Xh!^Xi!^X!P!^X!R!^X!X!^X!Y!^X!]!^X!j!^X!l!^X!m!^X!n!^X!o!^X#v!^X#w!^X#x!^X#y!^X#z!^X#{!^X$P!^X$W!^X$h!^X$T!^X~O|#cOg!aXh!aXi!aX!P!aX!R!aX!X!aX!Y!aX!]!aX!j!aX!l!aX!m!aX!n!aX!o!aX#v!aX#w!aX#x!aX#y!aX#z!aX#{!aX$P!aX$W!aX$h!aX$T!aX~O!O#gO~Og#iOh#jO$T#iOi!Ta!P!Ta!R!Ta!X!Ta!Y!Ta!]!Ta!j!Ta!l!Ta!m!Ta!n!Ta!o!Ta#v!Ta#w!Ta#x!Ta#y!Ta#z!Ta#{!Ta$P!Ta$W!Ta$h!Ta~O!O#kO~O|#lO~O|#oO~O|#sO~O!PqO!RqO!XqO!YqO!]#wO$h#yO~O$W$OO~O$T$PO~O|$QO$W$SO~O$W$TO~P,tOg#|Xh#|Xi#|X!P#|X!j#|X!l#|X!m#|X!n#|X!o#|X#v#|X#w#|X#x#|X#y#|X#z#|X#{#|X$W#|X~O$T$UO~P<[O!s$WO~P.eO$V$XO~OY#pXZ#pXj#pXk#pXl#pXm#pXn#pXo#pXp#pXq#pXr#pXs#pXt#pX!s#pX#v#pX#w#pX$S#pX$V#pX$X#pX$Y#pX$Z#pX$[#pX$]#pX$^#pX$_#pX$`#pX$a#pX$b#pX$c#pX$d#pX$e#pX$f#pX$g#pX~O`$ZOa$ZO~P=sO^!{O_!{O~P=sO$T$cO~P,tO$W$dO~O!O$fO~Oh$gOg![Xi![X!P![X!R![X!X![X!Y![X!]![X!j![X!l![X!m![X!n![X!o![X#v![X#w![X#x![X#y![X#z![X#{![X$P![X$W![X$h![X$T![X~O$V$hO~OV$iO!O#WO!k$jO!q$kO!s$lO~O|#cO!`$mOg!^ah!^ai!^a!P!^a!R!^a!X!^a!Y!^a!]!^a!j!^a!l!^a!m!^a!n!^a!o!^a#v!^a#w!^a#x!^a#y!^a#z!^a#{!^a$P!^a$W!^a$h!^a$T!^a~O}$oOg!dXh!dXi!dX!P!dX!R!dX!X!dX!Y!dX!]!dX!j!dX!l!dX!m!dX!n!dX!o!dX#v!dX#w!dX#x!dX#y!dX#z!dX#{!dX$P!dX$T!dX$W!dX$h!dX~O$T$pOg!eah!eai!ea!P!ea!R!ea!X!ea!Y!ea!]!ea!j!ea!l!ea!m!ea!n!ea!o!ea#v!ea#w!ea#x!ea#y!ea#z!ea#{!ea$P!ea$W!ea$h!ea~O$T$pOg!bah!bai!ba!P!ba!R!ba!X!ba!Y!ba!]!ba!j!ba!l!ba!m!ba!n!ba!o!ba#v!ba#w!ba#x!ba#y!ba#z!ba#{!ba$P!ba$W!ba$h!ba~Og#iOh#jO$T#iO$W$qO~O}$sO~O$T$tOg!uah!uai!ua!P!ua!R!ua!X!ua!Y!ua!]!ua!j!ua!l!ua!m!ua!n!ua!o!ua#v!ua#w!ua#x!ua#y!ua#z!ua#{!ua$P!ua$W!ua$h!ua~O}!XO!P!XO!Q!XO!R!XOg!{Xh!{Xi!{X!X!{X!Y!{X!]!{X!j!{X!l!{X!m!{X!n!{X!o!{X#v!{X#w!{X#x!{X#y!{X#z!{X#{!{X$P!{X$T!{X$W!{X$h!{X~O$T$uOg!yah!yai!ya!P!ya!R!ya!X!ya!Y!ya!]!ya!j!ya!l!ya!m!ya!n!ya!o!ya#v!ya#w!ya#x!ya#y!ya#z!ya#{!ya$P!ya$W!ya$h!ya~O}!XO!P!XO!Q!XO!R!XOg#OXh#OXi#OX!X#OX!Y#OX!]#OX!j#OX!l#OX!m#OX!n#OX!o#OX#v#OX#w#OX#x#OX#y#OX#z#OX#{#OX$P#OX$T#OX$W#OX$h#OX~O$T$vOg!|ah!|ai!|a!P!|a!R!|a!X!|a!Y!|a!]!|a!j!|a!l!|a!m!|a!n!|a!o!|a#v!|a#w!|a#x!|a#y!|a#z!|a#{!|a$P!|a$W!|a$h!|a~OU$wO~P*eO!k$zO~O!]${O$h#yO~O!PqO!RqO!XqO!YqO!]#wO~O[$}O$W#ca~P!#}O$W%SO~P;]O$W%TO~Oe{Of{Og#Qqh#Qqi#Qq!P#Qq!j#Qq!l#Qq!m#Qq!n#Qq!o#Qq#v#Qq#w#Qq#x#Qq#y#Qq#z#Qq#{#Qq$P#Qq$W#Qq$T#Qq~O$T%WO$W%XO~Oe{Of{Og#mqh#mqi#mq!P#mq!j#mq!l#mq!m#mq!n#mq!o#mq#v#mq#w#mq#x#mq#y#mq#z#mq#{#mq$P#mq$W#mq$T#mq~O$W%YO~P,tO$T%[O~P<[O#u%]O$W%`O~OY#paZ#paj#pak#pal#pam#pan#pao#pap#paq#par#pas#pat#pa!s#pa#v#pa#w#pa$S#pa$X#pa$Y#pa$Z#pa$[#pa$]#pa$^#pa$_#pa$`#pa$a#pa$b#pa$c#pa$d#pa$e#pa$f#pa$g#pa~O$V$XO~P!(WO`%bOa%bO$V#pa~P!(WOg!POi!PO!P!TO!j!TO!l!TO!m!TO!n!TO!o!TO#v!QO#w!QO#x#oq#y#oq#z#oq#{#oq$P#oq$W#oq~Oh#oq~P!*rOg#oqh#oqi#oq~P!*xOh!OO~P!*rO$P#oq$W#oq~P%aOg#oqh#oqi#oq!P#oq!j#oq!l#oq!m#oq!n#oq!o#oq#x#oq#y#oq#z#oq#{#oq~O#v!QO#w!QO$P#oq$W#oq~P!,mO!O%cO~O$W%dO~O!O%fO~O$V%gO~O$T$pOg!eih!eii!ei!P!ei!R!ei!X!ei!Y!ei!]!ei!j!ei!l!ei!m!ei!n!ei!o!ei#v!ei#w!ei#x!ei#y!ei#z!ei#{!ei$P!ei$W!ei$h!ei~O!O%hO~O|#cO~Og#iO$T#iOh!fii!fi!P!fi!R!fi!X!fi!Y!fi!]!fi!j!fi!l!fi!m!fi!n!fi!o!fi#v!fi#w!fi#x!fi#y!fi#z!fi#{!fi$P!fi$W!fi$h!fi~O|%jO!O%jO~O|%oO$j%qO$k%rO$l%sO~O[$}O$W#ci~O$i%uO~O$W#ci~P!#}O!k%xO~O!]${O$W#ci~O$W%zO~P;]O!]${O$W%zO$h#yO~O$W%|O~O|%}O~O$W&OO~P,tO$T&QO$W&RO~O$V$XOY#piZ#pij#pik#pil#pim#pin#pio#pip#piq#pir#pis#pit#pi!s#pi#v#pi#w#pi$S#pi$X#pi$Y#pi$Z#pi$[#pi$]#pi$^#pi$_#pi$`#pi$a#pi$b#pi$c#pi$d#pi$e#pi$f#pi$g#pi~O$T&TO~O$W&UO~O!O&VO~O$V&WO~Og#iOh#jO$T#iO!]#fi$h#fi$W#fi~O!]${O$W#cq~O$W#cq~P!#}O[$}O!]&ZO$W#cq~Oe{Of{Og#Q!Rh#Q!Ri#Q!R!P#Q!R!j#Q!R!l#Q!R!m#Q!R!n#Q!R!o#Q!R#v#Q!R#w#Q!R#x#Q!R#y#Q!R#z#Q!R#{#Q!R$P#Q!R$W#Q!R$T#Q!R~Oe{Of{Og#m!Rh#m!Ri#m!R!P#m!R!j#m!R!l#m!R!m#m!R!n#m!R!o#m!R#v#m!R#w#m!R#x#m!R#y#m!R#z#m!R#{#m!R$P#m!R$W#m!R$T#m!R~O$W&^O~P,tO#u%]O$W&`O~O!O&aO~O$W&bO~O|&cO~O!]${O$W#cy~O[$}O$W#cy~OU$wO~O!]&ZO$W#cy~O$T&fO~O$W&gO~O!]${O$W#c!R~O!O&iO~O$T&jO~O!O&kO~O$W&lO~OP!cOQ!bOR!eOS!dOT!dOW&mOX!jOb!lOc!mOd!nO|!aO$V!hO~O!]&nO$Txa~P+]O!]&nO$TxX~P#hOg&xOi&xO!P&|O!j&|O!l&|O!m&|O!n&|O!o&|O#v&yO#w&yO#x#oq#y#oq#z#oq#{#oq$T#oq~Oh#oq~P!=dOg#oqh#oqi#oq~P!=jOh&wO~P!=dOg&xOh&wOi&xO!P&|O!j&|O!l&|O!m&|O!n&|O!o&|O#v&yO#w&yO#x&zO#y&zO#z&zO#{&{O~O$T#oq~P!?QO#v&yO#w&yO$T#oq~P!,mO",
  goto: "0v$PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP$Q%P%h&W&ZPPPPPP&r'U'f't(VPP(f(nP(w(|P(w(w)P)Y(w)b)s)s)|PPPPPP)|P)sP(w(w*V*](w(w*d*g(w*m*p*v+i,O,e,e,e,e,e,e,e,e,e,e,e,e,e,e,e,z-T-h-t.^.a.a.a.d.s+i.v+i/]0R0d0m0pPPPPPPP+i+i+i[WOR|!z$U%[Q$]#OQ$^#PS$_#Q&sQ$`#RQ$a#SQ$b#TQ&}&qQ'O&rQ'P&tQ'Q&uQ'R&vR'S!Vt^O|!V!z#O#P#Q#R#S#T$U%[&q&r&s&t&u&vRxRjQOR|!V!z#O#P#Q#R#S#T$U%[S!sz$PQ#|!t]&p&q&r&s&t&u&vRpPQoP^!gu!h#i#j#w${&nQ#X!YS#p!m$uT#t!n$vQwQQ#x!sQ$|#{Q%Q#|Q%y%PR&o&p[vQ!s#{#|%P&p]!pw#x$|%Q%y&oitQw!s#x#{#|$|%P%Q%y&o&phsQw!s#x#{#|$|%P%Q%y&o&pR!`tkrQtw!s#x#{#|$|%P%Q%y&o&pQ!^rV#]!_#Y$gQ#^!_Q$e#YR%e$gV!ou#w&nR#b!bQ#e!bQ#f!cR$n#bU#d!b!c#bR%i$pU!iu#w&nQ#h!hQ$q#iQ$r#jR%v${_!gu!h#i#j#w${&n_!fu!h#i#j#w${&nQ#n!kR&h&mS#m!k&mR%k$tR#r!mQ#q!mR%l$uR#v!nQ#u!nR%m$vj^O#O#P#Q#R#S#T&q&r&s&t&u&vQyRQ!x|Q#U!VQ$V!zQ%Z$UR&P%[w]OR|!V!z#O#P#Q#R#S#T$U%[&q&r&s&t&u&vwTOR|!V!z#O#P#Q#R#S#T$U%[&q&r&s&t&u&vwSOR|!V!z#O#P#Q#R#S#T$U%[&q&r&s&t&u&vQ!uzQ#}!tR%V$PS#{!s#|W$y#x#z%Q%RQ%t$xQ%{%SR&Y%zQ%P#{Q%t$yQ&[%{R&d&YQ#z!sS$x#x%QQ%O#{Q%R#|S%w$|%PS&X%y%{R&e&[R%p$wR%n$wQ}VQ%U$OQ%Y$TQ&]%|R&^&OR$R!wwVOR|!V!z#O#P#Q#R#S#T$U%[&q&r&s&t&u&vQ#O!OQ#P!PQ#Q!QQ#R!RQ#S!SQ#T!TQ&q&wQ&r&xQ&s&yQ&t&zQ&u&{R&v&|h!|!O!P!Q!R!S!T&w&x&y&z&{&|R$[!}Q$Y!{Q%a$ZR&S%bR%^$XQ%_$XR&_&Q",
  nodeNames: "⚠ Json Logfmt Unpack Pattern Regexp Unwrap Ip LabelFormat LineFormat LabelReplace Vector Offset Bool On Ignoring GroupLeft GroupRight Decolorize Drop Keep By Without And Or Unless Sum Avg Count Max Min Stddev Stdvar Bottomk Topk Sort Sort_Desc LineComment LogQL Expr LogExpr Selector Matchers Matcher Identifier Eq String Neq Re Nre PipelineExpr PipelineStage LineFilters LineFilter Filter PipeExact PipeMatch FilterOp OrFilter Pipe LogfmtParser LogfmtParserFlags ParserFlag LabelParser JsonExpressionParser LabelExtractionExpressionList LabelExtractionExpression LogfmtExpressionParser LabelFilter IpLabelFilter UnitFilter DurationFilter Gtr Duration Gte Lss Lte Eql BytesFilter Bytes NumberFilter Number LineFormatExpr LabelFormatExpr LabelsFormat LabelFormatMatcher DecolorizeExpr DropLabelsExpr DropLabels DropLabel KeepLabelsExpr KeepLabels KeepLabel MetricExpr RangeAggregationExpr RangeOp CountOverTime Rate RateCounter BytesOverTime BytesRate AvgOverTime SumOverTime MinOverTime MaxOverTime StddevOverTime StdvarOverTime QuantileOverTime FirstOverTime LastOverTime AbsentOverTime LogRangeExpr Range OffsetExpr UnwrapExpr ConvOp BytesConv DurationConv DurationSecondsConv Grouping Labels VectorAggregationExpr VectorOp BinOpExpr BinOpModifier OnOrIgnoringModifier GroupingLabels GroupingLabelList GroupingLabel LabelName Add Sub Mul Div Mod Pow LiteralExpr LabelReplaceExpr VectorExpr",
  maxTerm: 166,
  skippedNodes: [0,37],
  repeatNodeCount: 0,
  tokenData: "5b~RvX^#ipq#iqr$^rs$qst%cuv%nxy%syz%xz{%}{|&S|}&X}!O&^!O!P(l!P!Q)l!Q!R)q!R![+X![!]2X!^!_2m!_!`2z!`!a3a!c!}3n!}#O4U#P#Q4Z#Q#R4`#R#S3n#S#T4e#T#o3n#o#p4q#p#q4v#q#r5]#y#z#i$f$g#i#BY#BZ#i$IS$I_#i$I|$JO#i$JT$JU#i$KV$KW#i&FU&FV#i~#nY$R~X^#ipq#i#y#z#i$f$g#i#BY#BZ#i$IS$I_#i$I|$JO#i$JT$JU#i$KV$KW#i&FU&FV#i~$aQ!_!`$g#r#s$l~$lO!P~~$qO!R~~$tUOY$qZr$qrs%Ws#O$q#O#P%]#P~$q~%]O!O~~%`PO~$q~%hQu~OY%cZ~%c~%sO#z~~%xO$V~~%}O$W~~&SO#x~~&XO#v~~&^O$T~~&cP#w~}!O&f~&iQ#_#`&o#g#h'|~&rP#X#Y&u~&xP#X#Y&{~'OP#d#e'R~'UP}!O'X~'[P#X#Y'_~'bP#a#b'e~'hP#d#e'k~'nP#h#i'q~'tP#m#n'w~'|O!`~~(PP#h#i(S~(VP#f#g(Y~(]P#]#^(`~(cP#V#W(f~(iP#h#i'w~(oP!Q![(r~(wR!s~!Q![(r!g!h)Q#X#Y)Q~)TR{|)^}!O)^!Q![)d~)aP!Q![)d~)iP!s~!Q![)d~)qO#y~~)ve!s~!O!P(r!Q![+X!g!h,l!i!j-Z!m!n-Z!o!p-Z!r!s-Z!v!w-Z#U#V-O#W#X-d#X#Y/f#Z#[/x#[#]-{#_#`/x#a#b0R#d#e/x#g#h/T#h#i/x#k#l0d#l#m1m#m#n1O~+^d!s~!O!P(r!Q![+X!g!h,l!i!j-Z!m!n-Z!o!p-Z!r!s-Z!v!w-Z#U#V-O#W#X-d#X#Y/f#Z#[/x#[#]-{#_#`/x#a#b0R#d#e/x#g#h/T#h#i/x#k#l0d#m#n1O~,oT{|)^}!O)^!Q![)d!d!e-O#]#^-T~-TO!q~~-WP#U#V-O~-^Q!d!e-O#]#^-T~-iP!k~!Q![-l~-oS!Q![-l#[#]-{#a#b.a#g#h/T~.QP!k~!Q![.T~.WR!Q![.T#a#b.a#g#h/T~.fQ!k~!Q![.l#g#h/O~.oR!Q![.l#a#b.x#g#h/T~.{P#g#h/O~/TO!k~~/YP!k~!Q![/]~/`Q!Q![/]#a#b.x~/iT{|)^}!O)^!Q![)d#U#V-O#]#^-T~/{Q#U#V-O#]#^-T~0WS!k~!Q![.l#U#V-O#]#^-T#g#h/O~0iP!k~!Q![0l~0oT!Q![0l#W#X-d#[#]-{#a#b.a#g#h/T~1TP!k~!Q![1W~1ZU!Q![1W#W#X-d#[#]-{#a#b.a#g#h/T#k#l0d~1pR!Q![1y!c!i1y#T#Z1y~2OR!s~!Q![1y!c!i1y#T#Z1yP2^T|P!Q![2X![!]2X!c!}2X#R#S2X#T#o2X~2rP!m~!_!`2u~2zO!n~~3PQ}~!_!`3V#r#s3[~3[O!o~~3aO!Q~~3fP!j~!_!`3i~3nO!l~R3uT|P#uQ!Q![3n![!]2X!c!}3n#R#S3n#T#o3n~4ZO$h~~4`O$i~~4eO#{~~4hRO#S4e#S#T%W#T~4e~4vO$S~~4{Q!]~!_!`5R#r#s5W~5WO!X~~5]O!Y~~5bO$U~",
  tokenizers: [0, 1],
  topRules: {"LogQL":[0,38]},
  specialized: [{term: 44, get: (value, stack) => (specializeIdentifier(value) << 1)},{term: 44, get: (value, stack) => (extendIdentifier(value) << 1) | 1},{term: 44, get: value => spec_Identifier[value] || -1}],
  tokenPrec: 0
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const Json = 1,
  Logfmt = 2,
  Unpack = 3,
  Pattern = 4,
  Regexp = 5,
  Unwrap = 6,
  Ip = 7,
  LabelFormat = 8,
  LineFormat = 9,
  LabelReplace = 10,
  Vector = 11,
  Offset = 12,
  Bool = 13,
  On = 14,
  Ignoring = 15,
  GroupLeft = 16,
  GroupRight = 17,
  Decolorize = 18,
  Drop = 19,
  Keep = 20,
  By = 21,
  Without = 22,
  And = 23,
  Or = 24,
  Unless = 25,
  Sum = 26,
  Avg = 27,
  Count = 28,
  Max = 29,
  Min = 30,
  Stddev = 31,
  Stdvar = 32,
  Bottomk = 33,
  Topk = 34,
  Sort = 35,
  Sort_Desc = 36,
  LineComment = 37,
  LogQL = 38,
  Expr = 39,
  LogExpr = 40,
  Selector = 41,
  Matchers = 42,
  Matcher = 43,
  Identifier = 44,
  Eq = 45,
  String = 46,
  Neq = 47,
  Re = 48,
  Nre = 49,
  PipelineExpr = 50,
  PipelineStage = 51,
  LineFilters = 52,
  LineFilter = 53,
  Filter = 54,
  PipeExact = 55,
  PipeMatch = 56,
  FilterOp = 57,
  OrFilter = 58,
  Pipe = 59,
  LogfmtParser = 60,
  LogfmtParserFlags = 61,
  ParserFlag = 62,
  LabelParser = 63,
  JsonExpressionParser = 64,
  LabelExtractionExpressionList = 65,
  LabelExtractionExpression = 66,
  LogfmtExpressionParser = 67,
  LabelFilter = 68,
  IpLabelFilter = 69,
  UnitFilter = 70,
  DurationFilter = 71,
  Gtr = 72,
  Duration = 73,
  Gte = 74,
  Lss = 75,
  Lte = 76,
  Eql = 77,
  BytesFilter = 78,
  Bytes = 79,
  NumberFilter = 80,
  Number = 81,
  LineFormatExpr = 82,
  LabelFormatExpr = 83,
  LabelsFormat = 84,
  LabelFormatMatcher = 85,
  DecolorizeExpr = 86,
  DropLabelsExpr = 87,
  DropLabels = 88,
  DropLabel = 89,
  KeepLabelsExpr = 90,
  KeepLabels = 91,
  KeepLabel = 92,
  MetricExpr = 93,
  RangeAggregationExpr = 94,
  RangeOp = 95,
  CountOverTime = 96,
  Rate = 97,
  RateCounter = 98,
  BytesOverTime = 99,
  BytesRate = 100,
  AvgOverTime = 101,
  SumOverTime = 102,
  MinOverTime = 103,
  MaxOverTime = 104,
  StddevOverTime = 105,
  StdvarOverTime = 106,
  QuantileOverTime = 107,
  FirstOverTime = 108,
  LastOverTime = 109,
  AbsentOverTime = 110,
  LogRangeExpr = 111,
  Range = 112,
  OffsetExpr = 113,
  UnwrapExpr = 114,
  ConvOp = 115,
  BytesConv = 116,
  DurationConv = 117,
  DurationSecondsConv = 118,
  Grouping = 119,
  Labels = 120,
  VectorAggregationExpr = 121,
  VectorOp = 122,
  BinOpExpr = 123,
  BinOpModifier = 124,
  OnOrIgnoringModifier = 125,
  GroupingLabels = 126,
  GroupingLabelList = 127,
  GroupingLabel = 128,
  LabelName = 129,
  Add = 130,
  Sub = 131,
  Mul = 132,
  Div = 133,
  Mod = 134,
  Pow = 135,
  LiteralExpr = 136,
  LabelReplaceExpr = 137,
  VectorExpr = 138;

function getNodeFromQuery(query, nodeType) {
  const nodes = [];
  const tree = parser.parse(query);
  tree.iterate({
    enter: (node) => {
      if (nodeType === undefined || nodeType === node.type.id) {
        nodes.push(node.node);
      }
    },
  });
  return nodes[0];
}

function isLogsQuery(query) {
  if (getNodeFromQuery(query, MetricExpr$1)) {
    return false;
  }
  return true;
}

function indent(level) {
  return '  '.repeat(level);
}

function indentMultiline(block, level) {
  const lines = block.split('\n');
  return lines.map((line) => indent(level) + line).join('\n');
}

function trimMultiline(block) {
  const lines = block.split('\n');
  return lines.map((line) => line.trimEnd()).join('\n');
}

function needsBrackets(node, queryType) {
  const childNodeIsSame = node.firstChild?.type.id === queryType;
  let addBrackets = false;

  if (node.firstChild && childNodeIsSame) {
    addBrackets = true;
    node = node.firstChild;
  }

  return { addBrackets, newNode: node };
}

function iterateNode(node, lookingFor) {
  const nodes = [];
  let child = node.firstChild;

  while (child) {
    if (lookingFor.includes(child.type.id)) {
      nodes.push(child);
    }

    nodes.push(...iterateNode(child, lookingFor));
    child = child.nextSibling;
  }

  return nodes;
}

function buildResponse(pipelineType, lastPipelineType, formattedNode) {
  if (lastPipelineType === pipelineType) {
    return ` ${formattedNode}`;
  }

  return `\n${indent(1)}${formattedNode}`;
}

function trimEnd(input, charactersToTrim) {
  let endIndex = input.length - 1;
  while (endIndex >= 0 && charactersToTrim.includes(input[endIndex])) {
    endIndex--;
  }
  return input.substring(0, endIndex + 1);
}

const formatLogExpr = (node, query) => {
  const { addBrackets, newNode } = needsBrackets(node, LogExpr);
  node = newNode;

  const tree = parser.parse(query.substring(node.from, node.to));
  let formatted = '';

  tree.iterate({
    enter: (ref) => {
      const node = ref.node;

      switch (node.type.id) {
        case Selector:
          formatted += formatSelector(node, query);
          break;

        case PipelineExpr:
          node.parent?.type.id !== PipelineExpr && (formatted += formatPipelineExpr(node, query));
          break;
      }
    },
  });

  return addBrackets ? '(' + formatted + ')' : formatted;
};

function formatSelector(node, query) {
  const selector = query.substring(node.from, node.to);
  const subtree = parser.parse(selector);
  const labelNodes = [];
  let response = '';

  subtree.iterate({
    enter: (ref) => {
      const node = ref.node;
      if (node.type.id === Matcher) {
        labelNodes.push(node);
      }
    },
  });

  labelNodes.sort((a, b) => {
    const labelNodeA = a.getChild(Identifier);
    const labelNodeB = b.getChild(Identifier);

    const labelValueA = labelNodeA && query.substring(labelNodeA.from, labelNodeA.to);
    const labelValueB = labelNodeB && query.substring(labelNodeB.from, labelNodeB.to);

    if (!labelValueA || !labelValueB) {
      return 0;
    }

    if (labelValueA < labelValueB) {
      return -1;
    }

    if (labelValueA > labelValueB) {
      return 1;
    }

    return 0;
  });

  labelNodes.forEach((node) => {
    const labelNode = node.getChild(Identifier);
    const operatorNode = labelNode ? labelNode.nextSibling : null;
    const valueNode = node.getChild(String);

    const label = labelNode ? query.substring(labelNode.from, labelNode.to) : null;
    const operator = operatorNode ? query.substring(operatorNode.from, operatorNode.to) : null;
    const value = valueNode ? query.substring(valueNode.from, valueNode.to) : null;

    response += `${label}${operator}${value}, `;
  });

  return '{' + trimEnd(response, ', ') + '}';
}

function formatPipelineExpr(node, query) {
  const pipelineExprNodes = [
    LineFilter,
    LabelParser,
    LogfmtParser,
    LabelFilter,
    JsonExpressionParser,
    LineFormatExpr,
    LabelFormatExpr,
    DecolorizeExpr,
  ];
  let lastPipelineType;
  let response = '';

  iterateNode(node, pipelineExprNodes).forEach((node) => {
    switch (node.type.id) {
      case LineFilter:
        response += buildResponse(LineFilter, lastPipelineType, formatLineFilter(node, query));
        lastPipelineType = LineFilter;
        break;

      case LabelParser:
        response += buildResponse(LabelParser, lastPipelineType, formatLabelParser(node, query));
        lastPipelineType = LabelParser;
        break;

      case LogfmtParser:
        response += buildResponse(LogfmtParser, lastPipelineType, formatLabelParser(node, query));
        lastPipelineType = LogfmtParser;
        break;

      case JsonExpressionParser:
        response += buildResponse(JsonExpressionParser, lastPipelineType, formatJsonExpressionParser(node, query));
        lastPipelineType = JsonExpressionParser;
        break;

      case LabelFilter:
        response += buildResponse(LabelFilter, lastPipelineType, formatLabelFilter(node, query));
        lastPipelineType = LabelFilter;
        break;

      case LineFormatExpr:
        response += buildResponse(LineFormatExpr, lastPipelineType, formatLineFormatExpr(node, query));
        lastPipelineType = LineFormatExpr;
        break;

      case LabelFormatExpr:
        response += buildResponse(LabelFormatExpr, lastPipelineType, formatLabelFormatExpr(node, query));
        lastPipelineType = LabelFormatExpr;
        break;

      case DecolorizeExpr:
        response += buildResponse(DecolorizeExpr, lastPipelineType, formatDecolorizeExpr());
        lastPipelineType = DecolorizeExpr;
        break;
    }
  });

  return response;
}

function formatLineFilter(node, query) {
  const filterNode = node.getChild(Filter);
  const filterOperationNode = node.getChild(FilterOp);
  const stringNode = node.getChild(String);

  const filter = filterNode && query.substring(filterNode.from, filterNode.to);
  const string = stringNode && query.substring(stringNode.from, stringNode.to);

  if (filterOperationNode) {
    return `${filter} ip(${string})`;
  }
  return `${filter} ${string}`;
}

function formatLabelParser(node, query) {
  const hasString = node.getChild(String);

  if (hasString) {
    const parserNode = node.getChild(Regexp) || node.getChild(Pattern);
    const stringNode = node.getChild(String);

    const parser = parserNode && query.substring(parserNode.from, parserNode.to);
    const string = stringNode && query.substring(stringNode.from, stringNode.to);

    return `| ${parser}${string}`;
  }

  const labelParser = query.substring(node.from, node.to);
  return `| ${labelParser}`;
}

function formatJsonExpressionParser(node, query) {
  const jsonExpressionNodes = iterateNode(node, [LabelExtractionExpression]);
  let response = '';

  jsonExpressionNodes.forEach((node) => {
    const identifierNode = node.getChild(Identifier);
    const valueNode = node.getChild(String);

    const identifier = identifierNode && query.substring(identifierNode.from, identifierNode.to);
    const value = valueNode && query.substring(valueNode.from, valueNode.to);

    response += `${identifier}=${value}, `;
  });

  return `| json ${trimEnd(response, ', ')}`;
}

function formatLabelFilter(node, query) {
  const selectedFilter =
    node.getChild(Matcher) ||
    node.getChild(IpLabelFilter) ||
    node.getChild(NumberFilter) ||
    node.getChild(UnitFilter)?.getChild(DurationFilter) ||
    node.getChild(UnitFilter)?.getChild(BytesFilter);

  if (!selectedFilter) {
    return '';
  }

  const selectedFilterType = selectedFilter.type.id;

  const identifierNode = selectedFilter.getChild(Identifier);
  const operatorNode = identifierNode && identifierNode.nextSibling;
  let valueNode;

  if (selectedFilterType === DurationFilter) {
    valueNode = selectedFilter.getChild(Duration);
  } else if (selectedFilterType === BytesFilter) {
    valueNode = selectedFilter.getChild(Bytes);
  } else if (selectedFilterType === NumberFilter) {
    valueNode = selectedFilter.getChild(Number);
  } else {
    valueNode = selectedFilter.getChild(String);
  }

  const identifier = identifierNode && query.substring(identifierNode.from, identifierNode.to);
  const operator = operatorNode && query.substring(operatorNode.from, operatorNode.to);
  const value = valueNode && query.substring(valueNode.from, valueNode.to);

  if (selectedFilterType === IpLabelFilter) {
    return `| ${identifier}${operator}ip(${value})`;
  }

  return `| ${identifier}${operator}${value}`;
}

function formatLineFormatExpr(node, query) {
  const stringNode = node.getChild(String);
  const string = stringNode && query.substring(stringNode.from, stringNode.to);
  return `| line_format ${string}`;
}

function formatLabelFormatExpr(node, query) {
  const labelFormatMatcherNodes = iterateNode(node, [LabelFormatMatcher]);
  let response = '| label_format ';

  labelFormatMatcherNodes.forEach((labelFormatMatcherNode) => {
    let identifierNode;
    let valueNode;

    if (labelFormatMatcherNode.getChildren(Identifier).length === 2) {
      [identifierNode, valueNode] = labelFormatMatcherNode.getChildren(Identifier);
    } else {
      identifierNode = labelFormatMatcherNode.getChild(Identifier);
      valueNode = labelFormatMatcherNode.getChild(String);
    }

    const identifier = identifierNode && query.substring(identifierNode.from, identifierNode.to);
    const value = valueNode && query.substring(valueNode.from, valueNode.to);

    response += `${identifier}=${value}, `;
  });

  return trimEnd(response, ', ');
}

function formatDecolorizeExpr() {
  return `| decolorize`;
}

const formatMetricExpr = (node, query) => {
  const { addBrackets, newNode } = needsBrackets(node, MetricExpr);
  node = newNode;
  let formatted = '';

  const childNode = node.firstChild;
  switch (childNode && childNode.type.id) {
    case RangeAggregationExpr:
      formatted = formatRangeAggregationExpr(node, query);
      break;

    case VectorAggregationExpr:
      formatted = formatVectorAggregationExpr(node, query);
      break;

    case BinOpExpr:
      formatted = formatBinOpExpr(node, query);
      break;

    case LiteralExpr:
      formatted = formatLiteralExpr(node, query);
      break;

    case LabelReplaceExpr:
      formatted = formatLabelReplaceExpr(node, query);
      break;

    case VectorExpr:
      formatted = formatVectorExpr(node, query);
      break;
  }

  return addBrackets ? '(' + formatted + ')' : formatted;
};

function formatRangeAggregationExpr(node, query) {
  let response = '';

  iterateNode(node, [RangeOp, Number, LogRangeExpr, Grouping]).forEach((node) => {
    if (node.parent?.type.id !== RangeAggregationExpr) {
      return;
    }

    switch (node.type.id) {
      case RangeOp:
        response += `${query.substring(node.from, node.to)}(\n`;
        break;

      case Number:
        response += `${indent(1) + query.substring(node.from, node.to)},\n`;
        break;

      case LogRangeExpr:
        response += formatLogRangeExpr(node, query);
        break;

      case Grouping:
        response += formatGrouping(node, query);
        break;
    }
  });

  return response;
}

function formatLogRangeExpr(node, query) {
  const nodes = [];
  let selector = '';
  let pipeline = '';
  let range = '';
  let offset = '';
  let unwrap = '';

  iterateNode(node, [Selector, Range, OffsetExpr, UnwrapExpr, PipelineExpr]).forEach((node) => {
    if (node.parent?.type.id !== LogRangeExpr) {
      return;
    }

    nodes.push(node);

    switch (node.type.id) {
      case Selector: {
        let logExpr = query.substring(node.from, node.to);
        selector += formatSelector({ ...node, from: 0, to: logExpr.length }, logExpr);
        break;
      }

      case PipelineExpr:
        pipeline += formatPipelineExpr(node, query);
        break;

      case Range:
        range += query.substring(node.from, node.to);
        break;

      case OffsetExpr: {
        const durationNode = node.getChild(Duration);
        offset += ` offset ${durationNode ? query.substring(durationNode.from, durationNode.to) : ''}`;
        break;
      }

      case UnwrapExpr:
        iterateNode(node, [Identifier, ConvOp, LabelFilter]).forEach((node, _, arr) => {
          switch (node.type.id) {
            case Identifier: {
              if (node.parent?.type.id !== UnwrapExpr) {
                return;
              }

              const hasConvOp = arr.find((node) => node.type.id === ConvOp);

              if (hasConvOp) {
                return;
              }

              unwrap += `| unwrap ${query.substring(node.from, node.to)} `;
              return;
            }

            case ConvOp: {
              const identifierNode = arr.find((node) => node.type.id === Identifier);
              const identifier = identifierNode ? query.substring(identifierNode.from, identifierNode.to) : '';
              unwrap += `| unwrap ${query.substring(node.from, node.to)}(${identifier}) `;
              return;
            }

            case LabelFilter:
              unwrap += formatLabelFilter(node, query);
              return;
          }
        });
        break;
    }
  });

  let response = '';
  nodes.forEach((node, index, array) => {
    const previousNode = array[index - 1];

    if (node.type.id === Selector) {
      response += indent(1) + selector;
    }

    if (node.type.id === PipelineExpr) {
      response += indentMultiline(pipeline, 1);
    }

    if (node.type.id === Range) {
      response += '\n' + indent(1) + range;
    }

    if (node.type.id === OffsetExpr) {
      response += offset;
    }

    if (node.type.id === UnwrapExpr) {
      if (previousNode?.type.id !== OffsetExpr && previousNode?.type.id !== Range) {
        response += '\n' + indent(1) + unwrap;
      } else {
        response += ' ' + unwrap;
      }
    }
  });

  return (response += '\n)');
}

function formatGrouping(node, query) {
  let response = '';

  const labels = iterateNode(node, [Identifier]).map((node) => {
    return query.substring(node.from, node.to);
  });

  iterateNode(node, [By, Without]).forEach((node) => {
    if (node.parent?.type.id !== Grouping) {
      return;
    }

    switch (node.type.id) {
      case By:
        response = ` by (${labels.join(', ')}) `;
        break;

      case Without:
        response = ` without (${labels.join(', ')}) `;
        break;
    }
  });

  return response;
}

function formatVectorAggregationExpr(node, query) {
  let response = '';

  iterateNode(node, [VectorOp, Number, MetricExpr, Grouping]).forEach((node, _, arr) => {
    if (node.parent?.type.id !== VectorAggregationExpr) {
      return;
    }

    switch (node.type.id) {
      case VectorOp:
        response += `${query.substring(node.from, node.to)}`;
        break;

      case Number:
        response += `(\n`;
        response += `${indent(1) + query.substring(node.from, node.to)},\n`;
        break;

      case MetricExpr: {
        const hasNumber = arr.find((node) => node.type.id === Number && node.parent?.type.id === VectorAggregationExpr);
        response += hasNumber ? '' : '(\n';

        const metricExpr = query.substring(node.from, node.to);
        const metricNode = getNodeFromQuery(metricExpr, MetricExpr);
        response += indentMultiline(formatMetricExpr(metricNode, metricExpr), 1);
        response += '\n)';
        break;
      }

      case Grouping:
        response += formatGrouping(node, query);
        break;
    }
  });

  return response;
}

function formatBinOpExpr(node, query) {
  let operator;

  const [leftExpr, rightExpr] = iterateNode(node, [Expr]).map((node, idx) => {
    if (idx === 0) {
      operator = query.substring(node.nextSibling?.from ?? 0, node.nextSibling?.to);
    }

    const expr = query.substring(node.from, node.to);
    let expressionNode;

    if (isLogsQuery(expr)) {
      expressionNode = getNodeFromQuery(expr, LogExpr);
      return formatLogExpr(expressionNode, expr);
    } else {
      expressionNode = getNodeFromQuery(expr, MetricExpr);
      return formatMetricExpr(expressionNode, expr);
    }
  });

  return leftExpr + '\n' + operator + '\n' + rightExpr;
}

function formatLiteralExpr(node, query) {
  node = node.getChild(LiteralExpr) ?? node;
  const addNode = node.getChild(Add);
  const subNode = node.getChild(Sub);
  const numberNode = node.getChild(Number);

  if (!numberNode) {
    return '';
  }

  if (addNode) {
    return `+${query.substring(numberNode.from, numberNode.to)}`;
  }

  if (subNode) {
    return `-${query.substring(numberNode.from, numberNode.to)}`;
  }

  return query.substring(numberNode.from, numberNode.to);
}

function formatLabelReplaceExpr(node, query) {
  let response = 'label_replace(\n';

  iterateNode(node, [MetricExpr, String]).forEach((node) => {
    if (node.parent?.type.id !== LabelReplaceExpr) {
      return;
    }

    if (node.type.id === MetricExpr) {
      const metricExpr = query.substring(node.from, node.to);
      const metricNode = getNodeFromQuery(metricExpr, MetricExpr);
      response += indentMultiline(formatMetricExpr(metricNode, metricExpr), 1) + ',\n';
    } else {
      response += indent(1) + query.substring(node.from, node.to) + ',\n';
    }
  });

  return trimEnd(response, ',\n') + '\n)';
}

function formatVectorExpr(node, query) {
  node = node.getChild(VectorExpr) ?? node;
  const numberNode = node.getChild(Number);

  if (!numberNode) {
    return '';
  }

  return `vector(${query.substring(numberNode.from, numberNode.to)})`;
}

/**
 * @experimental This feature is subject to change or removal in future versions.
 */
const formatLokiQuery = (query) => {
  const tree = parser.parse(query);
  let formatted = '';

  tree.iterate({
    enter: (ref) => {
      const node = ref.node;

      if (node.parent?.type.id !== Expr || node.parent?.parent?.type.id === BinOpExpr) {
        return;
      }

      switch (node.type.id) {
        case MetricExpr:
          formatted = formatMetricExpr(node, query);
          return false;

        case LogExpr:
          formatted = formatLogExpr(node, query);
          return false;
      }
    },
  });

  return trimMultiline(formatted);
};

export { AbsentOverTime, Add, And, Avg, AvgOverTime, BinOpExpr, BinOpModifier, Bool, Bottomk, By, Bytes, BytesConv, BytesFilter, BytesOverTime, BytesRate, ConvOp, Count, CountOverTime, Decolorize, DecolorizeExpr, Div, Drop, DropLabel, DropLabels, DropLabelsExpr, Duration, DurationConv, DurationFilter, DurationSecondsConv, Eq, Eql, Expr, Filter, FilterOp, FirstOverTime, GroupLeft, GroupRight, Grouping, GroupingLabel, GroupingLabelList, GroupingLabels, Gte, Gtr, Identifier, Ignoring, Ip, IpLabelFilter, Json, JsonExpressionParser, Keep, KeepLabel, KeepLabels, KeepLabelsExpr, LabelExtractionExpression, LabelExtractionExpressionList, LabelFilter, LabelFormat, LabelFormatExpr, LabelFormatMatcher, LabelName, LabelParser, LabelReplace, LabelReplaceExpr, Labels, LabelsFormat, LastOverTime, LineComment, LineFilter, LineFilters, LineFormat, LineFormatExpr, LiteralExpr, LogExpr, LogQL, LogRangeExpr, Logfmt, LogfmtExpressionParser, LogfmtParser, LogfmtParserFlags, Lss, Lte, Matcher, Matchers, Max, MaxOverTime, MetricExpr, Min, MinOverTime, Mod, Mul, Neq, Nre, Number, NumberFilter, Offset, OffsetExpr, On, OnOrIgnoringModifier, Or, OrFilter, ParserFlag, Pattern, Pipe, PipeExact, PipeMatch, PipelineExpr, PipelineStage, Pow, QuantileOverTime, Range, RangeAggregationExpr, RangeOp, Rate, RateCounter, Re, Regexp, Selector, Sort, Sort_Desc, Stddev, StddevOverTime, Stdvar, StdvarOverTime, String, Sub, Sum, SumOverTime, Topk, UnitFilter, Unless, Unpack, Unwrap, UnwrapExpr, Vector, VectorAggregationExpr, VectorExpr, VectorOp, Without, formatLokiQuery, parser };
